export default "__VITE_ASSET__C9Tvj1tn__"